export class HttpError extends Error {
  readonly headers: Headers;
  readonly ok: boolean;
  readonly redirected: boolean;
  readonly status: number;
  readonly statusText: string;
  //readonly trailer: Promise<Headers>;
  readonly type: ResponseType;
  readonly url: string;
  
  constructor(response: Response) {
    super(response.statusText);
    this.headers = response.headers;
    this.ok = response.ok;
    this.redirected = response.redirected;
    this.status = response.status;
    this.statusText = response.statusText;
    //this.trailer = response.trailer;
    this.type = response.type;
    this.url = response.url;
  }
}